import getApi from '../../api/apisauceConfig'
import { DocumentFormat } from '../../model/Document'
import { RenderableDocument, RenderableFile } from './mapper/documents.model'

export const renderPdfFromDocuments = (
  documents?: RenderableDocument[],
  files?: RenderableFile[],
  format: DocumentFormat = 'pdf',
  forPrint: boolean = false,
) =>
  getApi().post<Blob>(
    '/documents/render',
    { documents, files },
    { responseType: 'blob', params: { format, forPrint } },
  )
